import ctl from '@netlify/classnames-template-literals';

const emailSenderContainer = ctl(`
  w-1/2
  h-fit
  p-4 
  border 
  border-light-gray 
  bg-white 
  shadow-sm 
  mb-4 
  lg:mb-0  
  rounded-lg
`);

const labelStyle = ctl(`
  flex
  flex-col
  mb-4
`);

const textareaStyle = ctl(`
  border-b-black 
  border-2 
  border-solid 
  resize-none';
`);

const sendEmailButtonClasses = {
  container: 'bg-green-ncs',
};

const cancelEmailButtonClasses = {
  container: 'bg-transparent mr-[8px]',
  text: 'text-waterspout',
};

const buttonsContainer = ctl(`
  flex 
  items-start 
  gap-2 
  flex-wrap
`);

export default {
  emailSenderContainer,
  labelStyle,
  textareaStyle,
  sendEmailButtonClasses,
  cancelEmailButtonClasses,
  buttonsContainer,
};
